module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "relatorios-pagamentos-container",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "px-5 pb-5 pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-4 py-3"
  }, [_c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Filtros")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.periodoItems,
      "item-text": "text",
      "item-value": "value",
      "label": "Período",
      "single-line": ""
    },
    model: {
      value: (_vm.periodo),
      callback: function($$v) {
        _vm.periodo = $$v
      },
      expression: "periodo"
    }
  })], 1), _vm._v(" "), (_vm.periodo === 'custom') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "full-width": "",
      "offset-y": "",
      "close-on-content-click": false,
      "bottom": ""
    },
    model: {
      value: (_vm.dateMenu),
      callback: function($$v) {
        _vm.dateMenu = $$v
      },
      expression: "dateMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "value": ("De " + (_vm.formatDate(_vm.dataInicial)) + " até " + (_vm.formatDate(_vm.dataFinal))),
      "label": "Período customizado",
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "premium-input",
    attrs: {
      "type": "date",
      "label": "Data inicial"
    },
    on: {
      "input": _vm.onCustomDateInput
    },
    model: {
      value: (_vm.dataInicial),
      callback: function($$v) {
        _vm.dataInicial = $$v
      },
      expression: "dataInicial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "premium-input",
    attrs: {
      "type": "date",
      "label": "Data final"
    },
    on: {
      "input": _vm.onCustomDateInput
    },
    model: {
      value: (_vm.dataFinal),
      callback: function($$v) {
        _vm.dataFinal = $$v
      },
      expression: "dataFinal"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "grey darken-1"
    },
    on: {
      "click": function($event) {
        _vm.dateMenu = false
      }
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "disabled": !_vm.isCustomDateRangeValid
    },
    on: {
      "click": _vm.applyCustomDateRange
    }
  }, [_vm._v("Aplicar")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-select', {
    staticClass: "filtro-imovel",
    attrs: {
      "items": _vm.imovelItems,
      "item-text": "text",
      "item-value": "value",
      "label": "Imóvel",
      "autocomplete": "",
      "no-data-text": "Nenhum imóvel encontrado",
      "filter": _vm.imovelFilter,
      "clearable": "",
      "loading": _vm.imoveisLoading
    },
    on: {
      "input": _vm.onImovelInput,
      "change": _vm.onImovelInput
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('span', {
          staticClass: "filtro-imovel-selecao-title"
        }, [_vm._v(_vm._s(data.item.text))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('v-list-tile-content', {
          staticClass: "filtro-imovel-opcao-wrap"
        }, [_c('v-list-tile-title', {
          staticClass: "filtro-imovel-opcao-title"
        }, [_vm._v("\n                      " + _vm._s(data.item.text) + "\n                    ")])], 1)]
      }
    }]),
    model: {
      value: (_vm.selectedImovelId),
      callback: function($$v) {
        _vm.selectedImovelId = $$v
      },
      expression: "selectedImovelId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.statusItems,
      "label": "Status",
      "multiple": "",
      "chips": "",
      "clearable": ""
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey",
    attrs: {
      "dark": "",
      "disabled": _vm.itens.length < 1
    },
    nativeOn: {
      "click": function($event) {
        _vm.download('pdf')
      }
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('v-btn', {
    staticClass: "grey",
    attrs: {
      "dark": "",
      "disabled": _vm.itens.length < 1
    },
    nativeOn: {
      "click": function($event) {
        _vm.download('excel')
      }
    }
  }, [_vm._v("Excel")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4 resumo-card"
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Período aplicado")]), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v(_vm._s(_vm.periodoTitulo))])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4 resumo-card"
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Total de despesas")]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_c('strong', [_vm._v(_vm._s(_vm.resumo.total || 0))])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4 resumo-card"
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Valor total")]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.resumo.valor_total || 0)))])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "subheading mb-3"
  }, [_c('strong', [_vm._v("Resumo por status")])]), _vm._v(" "), (_vm.statusRows.length < 1) ? _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Sem dados para o período selecionado.")]) : _c('table', {
    staticClass: "resumo-status-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusRows), function(item) {
    return _c('tr', {
      key: item.status
    }, [_c('td', [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(item.valor_total)))])])
  }))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "subheading mb-3"
  }, [_c('strong', [_vm._v("Itens")])]), _vm._v(" "), (_vm.itens.length < 1) ? _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Nenhum pagamento encontrado para os filtros aplicados.")]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "itens-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Data ref.")]), _vm._v(" "), _c('th', [_vm._v("Vencimento")]), _vm._v(" "), _c('th', [_vm._v("Pagamento")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Imóvel")]), _vm._v(" "), _c('th', [_vm._v("Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Aprovador")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itens), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.data_referencia)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.data_vencimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.data_pagamento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatStatus(item.status)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descricao || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.imovel ? item.imovel.apelido : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitante ? item.solicitante.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.aprovador ? item.aprovador.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(item.valor)))])])
  }))])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24afe10f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Relatorios/RelatoriosPagamentos.vue
// module id = 997
// module chunks = 1